import { compose } from "@reduxjs/toolkit"
import withSettings from "../../hoc/withSettings"



 const Footer = (props:any) => {
    return (
      <div>
        {props.dictFunc('created footer')}<br/>
      </div>
    )
  }


  export default compose (
    withSettings
  )(Footer)